import { styled } from 'styletron-react'
import { padding, margin } from 'lostyle'
import { media, sizes, font, palette } from '../../style'

export const Wrapper = styled('div', (props) => ({
  ...media('tablet', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  })
}))
Wrapper.displayName = 'BlogArticle.Wrapper'

export const Title = styled('h1', (props) => ({
  ...margin('0'),
  ...padding('0'),
  letterSpacing: '-.03em',
  fontSize: '30px',
  lineHeight: '1.2',
  fontWeight: 600,
  ...media('tablet', {
    fontSize: '48px',
    lineHeight: '1.1',
  })
}))
Title.displayName = 'BlogArticle.Title'

export const Backdrop = styled('div', ({ $gradient, $color }) => ({
  width: '100%',
  height: 'auto',
  ...($gradient ? {
    background: $gradient
  } : {
    backgroundColor: palette.colors.reactBlue,
  }),
  color: $color ? $color : '#fff',
  ...media('tablet', {
    minHeight: '600px',
    height: '50vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end'
  }),
}))
Backdrop.displayName = 'BlogArticle.Backdrop'

export const BackdropContent = styled('div', (props) => ({
  width: '100%',
  ...padding({
    x: sizes.spacing.gutter.mobile,
    y: sizes.spacing.xl,
  }),
  ...media('tablet', {
    maxWidth: sizes.blog.maxWidth.desktop,
    ...padding({ x: sizes.spacing.gutter.desktop, y: sizes.spacing.huge}),
  }),
}))
BackdropContent.displayName = 'BlogArticle.BackdropContent'

export const CategoryList = styled('div', (props) => ({
  listStyleType: 'none',
  ...padding('0'),
  ...margin({
    top: sizes.spacing.s
  }),
}))
CategoryList.displayName = 'BlogArticle.CategoryList'

export const CategoryListItem = styled('div', (props) => ({
  display: 'inline-block',
  ...padding({ x: '6px', y: '5px' }),
  marginRight: '5px',
  fontWeight: 600,
  // textTransform: 'uppercase',
  letterSpacing: '1px',
  borderWidth: '1px',
  borderStyle: 'solid',
  fontSize: '10px',
  fontFamily: font.system
}))
CategoryListItem.displayName = 'BlogArticle.CategoryList.Item'

export const TimeStamp = styled('time', {
  fontSize: '12px',
  fontFamily: font.system,
  fontWeight: 400,
  display: 'block',
  ...margin({
    bottom: sizes.spacing.xxs
  }),
  ...media('tabletLandscape', {
    fontSize: '14px',
  })
})
TimeStamp.displayName = 'BlogArticle.TimeStamp'



// WEBPACK FOOTER //
// ./src/pages/BlogArticle/styles.js